import { atom } from 'recoil';
import { itemsIds } from '../utils/lookup-dictionaries/lookupItemList';

export const craftingAtom = atom({
	key: 'craftingAtom',
	default: itemsIds.log as number,
});
